<div class="page">
  <header class="page-h">
    <div>
      <h1 class="page-h__title">My forums</h1>
      <p class="page-h__desc">Topics you started or replied to, most recent activity first.</p>
    </div>
    <a class="ut-btn" uiSref="newDiscussion">
      <span class="material-icons" aria-hidden="true">add</span>
      New topic
    </a>
  </header>

  <p class="sr-only" role="status">{{ status }}</p>

  @if (store.feedItems.length) {
    <ul class="card topics">
      @for (topic of store.feedItems; track topic.id) {
        <li class="topic">
          <div class="topic__body">
            @if (topic.category) {
              <ut-category-link [category]="topic.category"></ut-category-link>
            }
            <a class="topic__title" [id]="'topic_' + topic.id" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }" [innerHTML]="topic.title | emojiHtml"></a>
            <span class="topic__meta">
              Started by {{ topic.user?.id === user.id ? 'you' : topic.user?.name }}
              @if (topic.commented_on_at) {
                · You replied {{ topic.commented_on_at | relativeDate }}
              }
              @if (topic.last_commented_at) {
                · Last reply {{ topic.last_commented_at | relativeDate }}
              }
            </span>
          </div>
          <span class="topic__count">
            <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
            @let count = replyCount(topic);
            {{ count }}<span class="sr-only"> {{ count === 1 ? 'reply' : 'replies' }}</span>
          </span>
        </li>
      }
    </ul>
  } @else if (store.isLoading) {
    <div class="list" aria-hidden="true">
      <div class="skeleton"></div>
      <div class="skeleton"></div>
    </div>
  } @else if (!store.failed) {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">forum</span></span>
      <p class="empty__title">No forum activity yet</p>
      <p class="empty__text">Topics you start or reply to will show up here.</p>
      <a class="ut-btn ut-btn--secondary" uiSref="discussion">Browse the forums</a>
    </div>
  }

  @if (store.failed && !store.isLoading) {
    <div class="alert alert--error" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <p class="alert__text"><b>Your topics couldn't load.</b> Check your connection and try again.</p>
      <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="retry()">Retry</button>
    </div>
  } @else if (store.feedItems.length && !store.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="store.isLoading" (click)="loadMore()">
      {{ store.isLoading ? 'Loading…' : 'View more' }}
    </button>
  }
</div>
